import { Layout } from '~/layouts';
import type { GetStaticProps } from 'next';
import { IProjects } from '~/types/projects';
import Projects from '~/components/Projects';

interface ProjectProps {
	projects: IProjects;
}

export const getStaticProps: GetStaticProps<ProjectProps> = async () => {
	const { default: rawProjects } = await import('~/data/projects.json');

	const projects = (rawProjects as IProjects).sort((a, b) => (a.priority < b.priority ? 1 : -1));

	return {
		props: {
			projects,
		},
	};
};

export default function ProjectsPage({ projects }: ProjectProps) {
	return (
		<Layout.Default seo={{ title: 'robio ─ projects' }}>
			<div className="mx-2 my-24 sm:mx-6 lg:mb-28 lg:mx-8">
				<div className="relative max-w-3xl mx-auto">
					<Projects data={projects} />
				</div>
			</div>
		</Layout.Default>
	);
}
